import TestemunhoIndividual from './TestemunhoIndividual';

function DonaZeze() {
    return <TestemunhoIndividual testimonialId={3} />;
}

export default DonaZeze;